import { render, staticRenderFns } from "./CmsProductRevisionListItem.vue?vue&type=template&id=909e9f32&scoped=true&"
import script from "./CmsProductRevisionListItem.vue?vue&type=script&lang=js&"
export * from "./CmsProductRevisionListItem.vue?vue&type=script&lang=js&"
import style0 from "./CmsProductRevisionListItem.vue?vue&type=style&index=0&id=909e9f32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909e9f32",
  null
  
)

export default component.exports